/**
 * Typed-name confirm for a hard, irreversible organization delete — same
 * shell as UsersPage/DeleteUserDialog.jsx.
 *
 * @param {Object=} organization - null closes the dialog
 * @param {boolean} busy
 * @param {*} error
 * @param {function} onConfirm
 * @param {function} onCancel
 */
import React, { useCallback, useEffect, useState } from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Input from "../../theme/untitled/Input/Input";
import Icon from "../../theme/untitled/icons/Icon";
import ApiError from "../../component/ApiError";
import styles from "./OrganizationsPage.module.scss";

const DeleteOrganizationDialog = ({ organization, busy, error, onConfirm, onCancel }) => {
  const [typedName, setTypedName] = useState("");

  useEffect(() => {
    setTypedName("");
  }, [organization?.uuid]);

  const onTypedNameChange = useCallback((e) => setTypedName(e.target.value), []);

  if (!organization) {
    return null;
  }

  const canConfirm = typedName === organization.name;

  return (
    <ConfirmDialog
      open
      onClose={onCancel}
      onConfirm={onConfirm}
      icon={<Icon name="Trash01" />}
      title={`Delete ${organization.name}?`}
      confirmLabel={busy ? "Deleting…" : error ? "Try again" : "Delete organization"}
      confirmDisabled={!canConfirm}
      busy={busy}
    >
      <div className={styles.dialogBody}>
        <p>This permanently deletes the organization, its calendars, alerts, and everything owned by it.</p>
        <p>This cannot be undone.</p>
        <div className={styles.confirmField}>
          <Input
            size="sm"
            label={`Type "${organization.name}" to confirm`}
            value={typedName}
            onChange={onTypedNameChange}
            disabled={busy}
            autoComplete="off"
          />
        </div>
        <ApiError error={error} defaultErrorMessage="Couldn't delete organization. Please try again" />
      </div>
    </ConfirmDialog>
  );
};

export default DeleteOrganizationDialog;
